import React, { useState } from 'react';
import PageContainer from '../layouts/PageContainer';

const ReportsScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState('class');
  
  const tabs = [
    { id: 'class', label: 'Class Progress' },
    { id: 'student', label: 'Student Performance' },
    { id: 'standards', label: 'Standards Mastery' }
  ];

  return (
    <PageContainer title="Reports" userRole="Teacher">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
          <div className="flex space-x-3">
            <button className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Print Report
            </button>
            <button className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Export Data
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow">
          <div className="flex border-b">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`px-6 py-3 text-sm font-medium ${
                  activeTab === tab.id
                    ? 'border-b-2 border-blue-500 text-blue-600'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          
          <div className="p-6">
            {activeTab === 'class' && (
              <div className="space-y-6">
                <div className="flex justify-between mb-4">
                  <div className="flex space-x-4">
                    <select className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500">
                      <option>Math 5A</option>
                      <option>Math 5B</option>
                    </select>
                    <select className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500">
                      <option>Last 30 Days</option>
                      <option>Last 60 Days</option>
                      <option>Last 90 Days</option>
                      <option>Custom Range</option>
                    </select>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Class Completion Rate</h3>
                    <p className="text-3xl font-bold text-blue-600">76%</p>
                    <p className="text-sm text-gray-500 mt-1">Average path completion</p>
                    <div className="mt-4 w-full bg-gray-200 rounded-full h-2.5">
                      <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: '76%' }}></div>
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Standards Mastered</h3>
                    <p className="text-3xl font-bold text-green-600">12/18</p>
                    <p className="text-sm text-gray-500 mt-1">Class average</p>
                    <div className="mt-4 w-full bg-gray-200 rounded-full h-2.5">
                      <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '67%' }}></div>
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Average Engagement</h3>
                    <p className="text-3xl font-bold text-purple-600">42 min</p>
                    <p className="text-sm text-gray-500 mt-1">Daily time spent</p>
                    <div className="mt-4 text-xs text-gray-500">
                      <div className="flex justify-between mb-1">
                        <span>Mon</span><span>Thu</span>
                      </div>
                      <div className="flex space-x-1">
                        <div className="h-16 w-1/5 bg-purple-200 rounded-t-sm relative">
                          <div className="absolute bottom-0 w-full bg-purple-600 rounded-t-sm" style={{ height: '60%' }}></div>
                        </div>
                        <div className="h-16 w-1/5 bg-purple-200 rounded-t-sm relative">
                          <div className="absolute bottom-0 w-full bg-purple-600 rounded-t-sm" style={{ height: '80%' }}></div>
                        </div>
                        <div className="h-16 w-1/5 bg-purple-200 rounded-t-sm relative">
                          <div className="absolute bottom-0 w-full bg-purple-600 rounded-t-sm" style={{ height: '50%' }}></div>
                        </div>
                        <div className="h-16 w-1/5 bg-purple-200 rounded-t-sm relative">
                          <div className="absolute bottom-0 w-full bg-purple-600 rounded-t-sm" style={{ height: '65%' }}></div>
                        </div>
                        <div className="h-16 w-1/5 bg-purple-200 rounded-t-sm relative">
                          <div className="absolute bottom-0 w-full bg-purple-600 rounded-t-sm" style={{ height: '40%' }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-8">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">Standards Progress</h3>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Standard
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Students Completed
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Avg. Score
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Avg. Time Spent
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Mastery Rate
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        <tr>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            5.NF.1 - Add and subtract fractions
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            20/24 (83%)
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            87%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            35 min
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                              <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '75%' }}></div>
                            </div>
                            <div className="text-xs text-gray-500 mt-1">75% Mastered</div>
                          </td>
                        </tr>
                        <tr>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            5.NF.2 - Solve word problems with fractions
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            18/24 (75%)
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            82%
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            42 min
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                              <div className="bg-green-600 h-2.5 rounded-full" style={{ width: '67%' }}></div>
                            </div>
                            <div className="text-xs text-gray-500 mt-1">67% Mastered</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            
            {activeTab === 'student' && (
              <div className="text-center py-12">
                <h3 className="text-lg font-medium text-gray-500">Select a class and student to view individual performance</h3>
              </div>
            )}
            
            {activeTab === 'standards' && (
              <div className="text-center py-12">
                <h3 className="text-lg font-medium text-gray-500">Select standards to view detailed mastery analytics</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default ReportsScreen;